export default "__VITE_ASSET__D6Iv_cDg__"